import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export function useMetaPixel() {
  useEffect(() => {
    // Initialize Meta Pixel
    if (typeof window !== 'undefined' && !window.fbq) {
      ;(function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
        if (f.fbq) return
        n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments)
        }
        if (!f._fbq) f._fbq = n
        n.push = n
        n.loaded = true
        n.version = '2.0'
        n.queue = []
        t = b.createElement(e)
        t.async = true
        t.src = v
        s = b.getElementsByTagName(e)[0]
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s)
        } else {
          b.head.appendChild(t)
        }
      })(
        window,
        document,
        'script',
        'https://connect.facebook.net/en_US/fbevents.js',
      )

      window.fbq('init', '964028326060040')
      window.fbq('track', 'PageView')
    }
  }, [])

  const trackAddToCart = (value?: number, currency: string = 'BRL') => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        value: value,
        currency: currency,
        content_name: 'Mega Pacote Artes Visuais',
        content_type: 'product',
      })
    }
  }

  return { trackAddToCart }
}
